// Fotos y videos reales del bar (subidos por el cliente a public/assets).
// Rutas relativas a la carpeta public, servidas tal cual por Create React App.
export const LOGO = '/assets/logo.jpg';
export const FOTO_MURO = '/assets/foto-muro.jpg';
export const FLYER_NOCHE_DE_CHICAS = '/assets/flyer-noche-de-chicas.jpg';
export const FLYER_FANFEST_MEXICO_INGLATERRA = '/assets/flyer-fanfest-mexico-inglaterra.jpg';
export const FLYER_FANFEST_MAPA = '/assets/flyer-fanfest-mapa.jpg';

export const HERO_VIDEOS = ['/assets/video-1.mp4', '/assets/video-2.mp4', '/assets/video-3.mp4'];
